import React from 'react';
import { CalendarCheck, ExternalLink } from 'lucide-react';
import { useBookingCountdown } from '../../hooks/useBookingCountdown';

// Shown once the chat has captured the visitor's contact info: opens Jess's
// Google Calendar booking page automatically, with a manual button fallback.
export const BookingCard = ({ message, sessionId }) => {
  const { status, markOpened } = useBookingCountdown(message.bookingUrl, sessionId);

  return (
    <div className="flex justify-start" data-testid="chat-booking-card">
      <div className="max-w-[90%] rounded-2xl rounded-bl-sm border border-gold-400/60 bg-gradient-to-br from-gold-50 to-white shadow-sm p-4 space-y-3">
        <p className="text-sm text-gray-800 leading-relaxed">{message.content}</p>
        <a
          href={message.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={markOpened}
          data-testid="chat-booking-link"
          className="flex items-center justify-center gap-2 w-full bg-[#143160] hover:bg-[#1E4A86] text-gold-300 font-bold text-sm py-3 rounded-xl transition-colors"
        >
          <CalendarCheck className="w-4 h-4" />
          Book an Appointment with Jess
          <ExternalLink className="w-3.5 h-3.5 opacity-70" />
        </a>
        <p className="text-[11px] text-gray-500 text-center" data-testid="chat-booking-status">{status}</p>
      </div>
    </div>
  );
};
